"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _iconCheckmark = _interopRequireDefault(require("../../../shared/icons/icon-checkmark.svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var WithCheckmark = function ListItemWithCheckmark(_ref) {
  var currentClass = _ref.currentClass,
      children = _ref.children,
      baseClass = _ref.baseClass;
  return /*#__PURE__*/_react["default"].createElement("li", {
    className: "".concat(currentClass, " ").concat(currentClass, "--checkmark")
  }, /*#__PURE__*/_react["default"].createElement(_iconCheckmark["default"], {
    className: "".concat(baseClass, "-list__icon")
  }), /*#__PURE__*/_react["default"].createElement("p", null, children));
};

WithCheckmark.propTypes = {
  children: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
  baseClass: _propTypes["default"].string.isRequired,
  currentClass: _propTypes["default"].string.isRequired
};
var _default = WithCheckmark;
exports["default"] = _default;